<template>
  <div>
    <!-- tags -->
    <b-row class="justify-content-center mt-5">
      <b-col cols="12" md="8">
        <b-row class="justify-content-center">
          <b-col class="custom-select-autocomplete p-0" cols="10">
            <label>{{ $t("general.etiquettes") }} :</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col cols="12" md="8">
        <b-row class="justify-content-center">
          <b-col class="custom-select-autocomplete p-0" cols="7">
            <b-input
              ref="v-input"
              class="custom-select-autocomplete-input"
              autocomplete="off"
              :value="defaultTag.name"
              @input="input"
              @focus="focus"
              @blur="blur"
            />
            <v-select
              ref="v-select"
              class="custom-select-autocomplete-select"
              :reduce="name => name.id"
              :options="tags"
              label="name"
              @input="select($event)"
            >
              <span slot="no-options">
                {{ $t("general.select_with_input_no_option") }}
              </span>
            </v-select>
          </b-col>
          <b-col cols="3">
            <b-button
              :disabled="defaultTag.name.length == 0"
              class="button btn-blue btn-filter"
              @click="CREATE_TAG"
            >
              <font-awesome-icon class="agv-button-icon" icon="plus" />
              <span>{{ $t("general.newtag") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col class="mx-auto d-inline-flex flex-wrap my-3" cols="12" sm="10" md="8">
        <b-card
          v-for="(tag, index) in resolutionCatalog.tags"
          :key="index"
          class="my-1 mx-1"
          body-class="py-1 px-2 text-nowrap"
        >
          <strong class="mr-1">{{ tag.name }}</strong>
          <font-awesome-icon
            style="cursor: pointer;"
            icon="times-circle"
            @click="DETACH_TAG(tag)"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TagORM from "@/store/orm-axios/models/Tag";
import TagMW from "@/middlewares/Tag";
import ResolutionCatalogORM from "@/store/orm-axios/models/ResolutionCatalog";

export default {
  props: {
    resolutionCatalog: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      defaultTag: {
        agency_id: Number(localStorage.getItem("agencyId")),
        name: "",
      },
    };
  },
  computed: {
    tags() {
      var tags = TagORM.query().where("agency_id", this.agencyId).get();
      var tagsProcessed = [];
      tags.forEach(tag => {
        if (!this.$_.findWhere(this.resolutionCatalog.tags, { id: tag.id })) {
          tagsProcessed.push(tag);
        }
      });
      return tagsProcessed;
    },
  },
  async created() {
    await TagMW.FETCH(this.agencyId);

    this.updateResolutionCatalogTags();
  },
  methods: {
    updateCatalog(key, value) {
      this.$emit("updateCatalog", key, value);
    },
    updateResolutionCatalogTags() {
      var tags = ResolutionCatalogORM.query()
        .where("id", this.resolutionCatalog.id)
        .withAllRecursive()
        .first().tags;
      this.updateCatalog("tags", tags);
    },
    // input + select + autocomplete functions
    input(e) {
      // console.log(e);
      this.defaultTag.name = e;
      this.$refs["v-select"].search = e;
    },
    focus(e) {
      // console.log(e);
      this.$refs["v-select"].open = true;
    },
    blur(e) {
      // console.log(e);
      this.$refs["v-select"].open = false;
    },
    select(e) {
      // console.log(e);
      this.ATTACH_TAG(e);
    },
    CREATE_TAG() {
      TagMW.POST(this.defaultTag, this.resolutionCatalog.id)
        .then(res => {
          this.$refs["v-input"].blur();

          this.defaultTag.name = "";
          this.$refs["v-select"].search = "";

          this.updateResolutionCatalogTags();
        })
        .catch(err => {
          console.log("error", err);
        });
    },
    ATTACH_TAG(tagId) {
      TagMW.ATTACH(tagId, this.resolutionCatalog.id)
        .then(res => {
          this.$refs["v-input"].blur();

          this.updateResolutionCatalogTags();
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    DETACH_TAG(tag) {
      TagMW.DETACH(tag.id, this.resolutionCatalog.id, tag.pivot.id)
        .then(res => {
          this.updateResolutionCatalogTags();
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    // ???: delete tags??
  },
};
</script>
